// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const Viewlst_481 = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'Lst_481',
        name: 'Cuota 481',
        component: Viewlst_481,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
